import React, { useState } from 'react';

const DropDownSelect = ({ setIsAssignedToMe }) => {
  const [selected, setSelected] = useState('');

  React.useEffect(() => {
    const saved = localStorage.getItem('assignedValue');
    if (saved) {
      const value = JSON.parse(saved);
      setSelected(value);
      setIsAssignedToMe(value === 'Assign to me');
    }
  }, []);
  const handleChange = (e) => {
    setSelected(e.target.value);
    localStorage.setItem('assignedValue', JSON.stringify(e.target.value));
    if (e.target.value === 'Assign to me') {
      setIsAssignedToMe(true);
    } else {
      setIsAssignedToMe(false);
    }
  };
  const assignee = [
    { value: 'Assign to me', label: 'Assign to me' },
    { value: 'Assign to all', label: 'Assign to all' }
  ];
  return (
    <div className="flex items-center gap-4">
      <label htmlFor="fruit" className="block text-sm font-medium text-[#4A4A4A] mb-1">
        Showing
      </label>
      <div className="relative">
        <select
          id="fruit"
          name="fruit"
          value={selected}
          onChange={handleChange}
          className="assignee-dropdown block appearance-none w-full border px-3 py-2 pr-10 text-md  bg-white shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
        >
          {assignee.map((val) => (
    <option key={val.value} value={val.value}>
      {val.label}
    </option>
  ))}
        </select>
      </div>
    </div>
  );
};

export default DropDownSelect;
